import { useRef, useState } from "react";
import { motion as Motion, useInView } from "framer-motion";
import { useSelector } from "react-redux";
import { FiLock } from "react-icons/fi";
// import { callBuildSolutionFormApiService } from '../../../../api/services/formService';
import { FaArrowRight } from "react-icons/fa6";


import { useDispatch } from 'react-redux';
import { openModal } from '../../../../redux/slices/modalSlice';

import "./BuildSolution.scss";

export default function BuildSolution() {
    const sectionRef = useRef(null);
    const isInView = useInView(sectionRef, { amount: 0.3, once: false });
    const [industry, setIndustry] = useState("");
    const [problem, setProblem] = useState("");
    const [email, setEmail] = useState("");
    const [showResults, setShowResults] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false);


    const dispatch = useDispatch();

    const handleOpenContactModal = () => {
        dispatch(openModal({
            modalType: 'contact',
            modalProps: {
            }
        }));
    };

    const { buildSolution: buildSolutionData } = useSelector((state) => state.global);

    const industries = buildSolutionData?.industries;

    const variants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    const handleGetResult = () => {
        if (industry && problem) {
            const wordCount = problem.trim().split(/\s+/).filter(Boolean).length;
            if (wordCount >= 15) {
                setIsSubmitting(true);
                setTimeout(() => {
                    setShowResults(true);
                    setIsSubmitting(false);
                }, 1000);
            }
            else {
                // toast.error(`Please describe your problem in at least 30 words.`);
            }
        }
    };

    const handleTalkToExpert = () => {
        handleOpenContactModal();
    };

    const handleSubmitSolution = () => {
        if (email) {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(email)) {
                // toast.error("Invalid email address");
                return;
            }

            const formData = {
                email: email,
                topic: industry,
                message: problem
            }
            // callBuildSolutionFormApiService(formData)
        }
    };

    if (!buildSolutionData) return null;

    return (
        <section className="solution-builder" ref={sectionRef} >
            <div className="solution-container">
                <Motion.h2
                    className="solution-heading"
                    initial="hidden"
                    animate={isInView ? "visible" : "hidden"}
                    variants={variants}
                >
                    {buildSolutionData.heading?.toUpperCase()}
                </Motion.h2>

                <Motion.p
                    className="solution-subheading"
                    initial="hidden"
                    animate={isInView ? "visible" : "hidden"}
                    variants={variants}
                    transition={{ delay: 0.1 }}
                >
                    {buildSolutionData.subheading}
                </Motion.p>

                <Motion.div
                    className="solution-box"
                    initial="hidden"
                    animate={isInView ? "visible" : "hidden"}
                    variants={variants}
                    transition={{ delay: 0.2 }}
                >
                    <div className="form-group">
                        <label htmlFor="industry">Choose Your Industry</label>
                        <select
                            id="industry"
                            value={industry}
                            onChange={(e) => setIndustry(e.target.value)}
                            disabled={showResults}
                        >
                            <option value="">Select your industry</option>
                            {industries.map((item, index) => (
                                <option key={index} value={item}>{item}</option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="problem">Describe your problem <span style={{ color: "#555", fontSize: "10px" }}>{problem?.length > 0 && `- ${problem.trim().split(/\s+/).filter(Boolean).length} `}</span></label>
                        <textarea
                            id="problem"
                            value={problem}
                            onChange={(e) => setProblem(e.target.value)}
                            rows={5}
                            placeholder="Briefly describe the challenge you're facing..."
                            disabled={showResults}
                        />
                    </div>

                    {!showResults && (
                        <div className="solution-actions">
                            <button
                                className="btn-primary"
                                onClick={handleGetResult}
                                disabled={!industry || !problem || isSubmitting}
                            >
                                {isSubmitting ? "Processing..." : <span style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                    {buildSolutionData?.Button1Text?.name || "Get Solution"} <FaArrowRight fontSize={16} />
                                </span> || "Get Solution"}

                            </button>
                            <button
                                className="btn-secondary"
                                onClick={handleTalkToExpert}
                                disabled={isSubmitting}
                            >
                                {buildSolutionData?.Button2Text?.name || "Talk to an Expert"}
                            </button>
                        </div>
                    )}

                    {showResults && (
                        <Motion.div
                            className="solution-results"
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className="results-content">
                                <h3 className="results-heading">SOLUTION</h3>
                                <div className="results-text">
                                    <p>Based on your {industry.toLowerCase()} industry needs and the challenge you described, we recommend a comprehensive digital transformation strategy.</p>
                                    <p>Our team specializes in creating tailored solutions that address specific pain points in the {industry.toLowerCase()} sector. We'll develop a scalable platform that integrates seamlessly with your existing systems while providing room for future growth.</p>
                                    <p>The proposed solution includes advanced analytics, cloud integration, and user-centric design to ensure optimal performance and customer satisfaction.</p>
                                </div>

                                <div className="results-overlay">
                                    <div className="lock-icon">
                                        <FiLock size={24} />
                                        Get full report on your mail
                                    </div>
                                    <div className="gradient-overlay"></div>
                                </div>

                                <div className="email-input-section">
                                    <div className="form-group">
                                        <label htmlFor="email">Enter your email to unlock full solution</label>
                                        <input
                                            id="email"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Enter your email address"
                                            className="email-input"
                                        />
                                    </div>

                                    <div className="solution-actions">
                                        <button
                                            className="btn-primary"
                                            onClick={handleSubmitSolution}
                                            disabled={!email}
                                        >
                                            <span style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                                {buildSolutionData?.Button1Text?.name || "Get Solution"} <FaArrowRight fontSize={16} />
                                            </span>

                                        </button>
                                        <button
                                            className="btn-secondary"
                                            onClick={handleTalkToExpert}
                                        >

                                            {buildSolutionData?.Button2Text?.name || "Talk to an Expert"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Motion.div>
                    )}
                </Motion.div>
            </div>
        </section>
    );
}